const STORAGE_KEY_PREFIX = "seen_event_";

export function hasSeenEvent(eventId: number) {
  return localStorage.getItem(`${STORAGE_KEY_PREFIX}${eventId}`) === "1";
}

export function markEventSeen(eventId: number) {
  localStorage.setItem(`${STORAGE_KEY_PREFIX}${eventId}`, "1");
}
